import { useRouter } from 'next/router';
import React from 'react';

import useAppDownloadCujModal from '@/hooks/cuj/useAppDownloadCujModal';
import { setAppDownloadCujModalState } from '@/recoil/atoms/cuj';
import { getPageName, logger } from '@/utils/logger';

const AppDownloadCujModal = () => {
  const router = useRouter();
  const { handleAppDownload } = useAppDownloadCujModal();

  const onClickAppDownload = () => {
    logger({
      pageName: getPageName(router),
      eventName: 'app_download_modal_click',
    });

    setAppDownloadCujModalState({
      isShow: false,
    });

    handleAppDownload('지금 앱으로 진료받기');
  };

  return (
    <div className='mx-10 flex w-full flex-col items-center gap-10'>
      <div className='flex flex-col gap-1 text-center'>
        <span className='typography-ui-19sb text-white'>대한민국 1위 비대면 진료 앱 닥터나우</span>
        <div className='typography-ui-28b flex flex-col items-center text-primary-700'>
          <span>늦은 밤, 주말에도</span>
          <span>진료 가능해요</span>
        </div>
      </div>
      <div className='flex flex-col items-center'>
        <div className='w-[188px] overflow-hidden rounded-t-[20px] bg-gray-30 p-1'>
          <img className='w-full rounded-lg' src='/images/qna/appHomeScreen.png' alt='app_home_screen' />
        </div>
        <button
          className='typography-ui-17sb h-14 w-60 rounded-xl bg-primary-600 text-white'
          type='button'
          onClick={onClickAppDownload}
        >
          지금 앱으로 진료받기
        </button>
      </div>
    </div>
  );
};

export default AppDownloadCujModal;
